import { getErrorMessage } from "@/core/api/helpers"
import { useAppDispatch } from "@/redux/hooks"
import { useAddAIPromptMutation } from "@/redux/services/aiPromptsApi"
import { setToast } from "@/redux/toastSlice"
import type { AiPromptPayload } from "@/types/entities/ai-prompt"

export const useAddAiPrompt = () => {
  const dispatch = useAppDispatch()
  const [addAiPrompt, response] = useAddAIPromptMutation()

  const handleAddAiPrompt = async (body: AiPromptPayload) => {
    try {
      const response = await addAiPrompt(body).unwrap()
      if (response) {
        dispatch(
          setToast({
            show: true,
            variant: "success",
            message: "Success add prompt",
          }),
        )
      }
    } catch (error: any) {
      const message = getErrorMessage(error)
      dispatch(
        setToast({
          show: true,
          variant: "error",
          message,
        }),
      )
      throw new Error(message)
    }
  }

  return { addAIPrompt: handleAddAiPrompt, response }
}
